import { useState } from "react"
import AuthenticatedLayout from "@components/layout/Authenticated"
import { Box, Text, HStack, Button, ButtonGroup, MenuItem, useDisclosure} from "@chakra-ui/react"
import { RiArrowDownLine, RiArrowUpLine, RiArrowRightUpLine} from "@remixicon/react"
import { localNumber } from "@utils/helpers"
import ProductList from "@modules/product/components/Product/ProductList"
import { StatAsset, StatCard, MenuAsset, LinkAsset} from "@utils/assets"
import PageHeader from "@components/header/components/PageHeader"
import { Link } from "react-router-dom"
import ReviewList from "@modules/product/components/Review/ReviewList"
import Statistics from "@components/header/components/StatDate"

const Index = () => {

    const [stat, setStat] = useState({})

    const { approved_reviews, pending_reviews } = stat || {}

    const PageHeaderAction = () => (
        <Statistics setStat={setStat} />
    )

    return (
        <AuthenticatedLayout title={'Reviews | Monitor Customer Feedback and Ratings'}>

           <Box className="w-full h-full">

                <Box className="mb-5">
                    <PageHeader
                        title={'Product Reviews'}
                        description={`Access and manage customer reviews to ensure quality control, build trust, and improve product offerings.`}
                        action={PageHeaderAction}
                    />
                </Box>


                <Box className="content">

                    <Box className="mb-4 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-3 sm:grid-cols-1 gap-4">
                        
                        <Box className="bg-gray-50 p-5">
                            <StatCard
                                label={'Approved Reviews'}
                                number={localNumber({number: approved_reviews?.number, decimals: 0})}
                                helper={`${localNumber({number: approved_reviews?.trend?.percentage, decimals: 2})}% In ${approved_reviews?.trend?.period}`}
                                arrow={approved_reviews?.trend?.arrow}
                            />
                        </Box>

                        <Box className="bg-gray-50 p-5">
                            <StatCard
                                label={'Pending Reviews'}
                                number={localNumber({number: pending_reviews?.number, decimals: 0})}
                                helper={`${localNumber({number: pending_reviews?.trend?.percentage, decimals: 2})}% In ${pending_reviews?.trend?.period}`}
                                arrow={pending_reviews?.trend?.arrow}
                            />
                        </Box>

                    </Box>

                    <Box>
                        <ReviewList />
                    </Box>

                </Box>

               
           </Box>
        
        </AuthenticatedLayout>
    )

}


export default Index